import { makeAutoObservable } from "mobx";
import { AuthStore, authStore } from "./AuthStore";
import { ToastStore, toastStore } from "./ToastStore";
import {
  contractorDetailStore,
  type ContractorDetailStore,
} from "./ContractorDetailStore";
import { contractorsStore } from "./ContractorsStore";
import type { ContractorsStore } from "./ContractorsStore";
import { popoverStore } from "./PopoverStore";
import type { PopoverStore } from "./PopoverStore";
import {
  serviceCenterFormStore,
  type ServiceCenterFormStore,
} from "./ServiceCenterFormStore";
import { clientDetailStore, type ClientDetailStore } from "./ClientDetailStore";
import { clientsStore } from "./ClientsStore";
import type { ClientsStore } from "./ClientsStore";
import { feedbackStore } from "./FeedbackStore";
import type { FeedbackStore } from "./FeedbackStore";
import { feedbackSettingsStore } from "./FeedbackSettingsStore";
import type { FeedbackSettingsStore } from "./FeedbackSettingsStore";
import { gasStationsStore } from "./GasStationsStore";
import type { GasStationsStore } from "./GasStationsStore";
import { gasStationFormStore } from "./GasStationFormStore";
import type { GasStationFormStore } from "./GasStationFormStore";
import { helpStore } from "./HelpStore";
import type { HelpStore } from "./HelpStore";
import { helpSettingsStore } from "./HelpSettingsStore";
import type { HelpSettingsStore } from "./HelpSettingsStore";
import { pushCampaignsStore } from "./PushCampaignsStore";
import type { PushCampaignsStore } from "./PushCampaignsStore";
export class RootStore {
  authStore: AuthStore;
  toastStore: ToastStore;
  contractorDetailStore: ContractorDetailStore;
  contractorsStore: ContractorsStore;
  popoverStore: PopoverStore;
  serviceCenterFormStore: ServiceCenterFormStore;
  clientDetailStore: ClientDetailStore;
  clientsStore: ClientsStore;
  feedbackStore: FeedbackStore;
  feedbackSettingsStore: FeedbackSettingsStore;
  gasStationsStore: GasStationsStore;
  gasStationFormStore: GasStationFormStore;
  helpStore: HelpStore;
  helpSettingsStore: HelpSettingsStore;
  pushCampaignsStore: PushCampaignsStore;

  constructor() {
    this.authStore = authStore;
    this.toastStore = toastStore;
    this.contractorDetailStore = contractorDetailStore;
    this.contractorsStore = contractorsStore;
    this.popoverStore = popoverStore;
    this.serviceCenterFormStore = serviceCenterFormStore;
    this.clientDetailStore = clientDetailStore;
    this.clientsStore = clientsStore;
    this.feedbackStore = feedbackStore;
    this.feedbackSettingsStore = feedbackSettingsStore;
    this.gasStationsStore = gasStationsStore;
    this.gasStationFormStore = gasStationFormStore;
    this.helpStore = helpStore;
    this.helpSettingsStore = helpSettingsStore;
    this.pushCampaignsStore = pushCampaignsStore;
    makeAutoObservable(this);
  }
}

export const rootStore = new RootStore();
